/** User-facing labels for admin-configured free ticket grant periods. */

export function normalizeFreeTicketPeriodDays(periodDays) {
  const n = parseInt(periodDays, 10);
  return Number.isFinite(n) && n >= 1 ? n : 1;
}

export function normalizeTicketCount(value, fallback = 0) {
  const n = parseInt(value, 10);
  return Number.isFinite(n) && n >= 0 ? n : fallback;
}

export function freeTicketPeriodLabel(periodDays) {
  if (periodDays == null || periodDays === '') return 'Free tickets';
  const days = normalizeFreeTicketPeriodDays(periodDays);
  if (days === 1) return 'Daily free tickets';
  return `Free tickets (${days}-day period)`;
}

export function freeTicketPeriodShortLabel(periodDays) {
  if (periodDays == null || periodDays === '') return 'Free tickets';
  const days = normalizeFreeTicketPeriodDays(periodDays);
  if (days === 1) return 'Daily (normal)';
  return `Period (${days}d)`;
}

/** e.g. "3 tickets every 7 days" from admin dailyFreeTickets + freeTicketPeriodDays. */
export function freeTicketGrantCaption({ dailyLimit, periodDays } = {}) {
  if (dailyLimit == null && periodDays == null) return null;
  const tickets = normalizeTicketCount(dailyLimit, 0);
  const days = normalizeFreeTicketPeriodDays(periodDays);
  const unit = tickets === 1 ? 'ticket' : 'tickets';
  if (days === 1) return `${tickets} free ${unit} every day`;
  return `${tickets} free ${unit} every ${days} days`;
}

export function freeTicketRemainingCaption({ platformTickets, dailyLimit } = {}) {
  if (dailyLimit == null) return null;
  const grant = normalizeTicketCount(dailyLimit, 0);
  const remaining = platformTickets != null ? normalizeTicketCount(platformTickets, 0) : null;
  if (remaining == null) return `${grant} per period`;
  return `${remaining} of ${grant} remaining this period`;
}

export function freeTicketResetHint(periodDays, nextResetAt) {
  const days =
    periodDays == null || periodDays === '' ? null : normalizeFreeTicketPeriodDays(periodDays);
  if (nextResetAt) {
    const d = new Date(nextResetAt);
    if (!Number.isNaN(d.getTime())) {
      return `Resets ${d.toLocaleDateString()} · use on free predictions`;
    }
  }
  if (days == null) return 'Use on free predictions';
  if (days === 1) return 'Resets daily · use on free predictions';
  return `Resets every ${days} days · use on free predictions`;
}
